export default {
  chapter: {
    SET_CATALOGS: '_primary_course_set_catalogs',
    SET_LESSON: '_primary_course_set_lesson',
    CLEAR_CHAPTER_DATA: '_primary_course_clear_chapter_data',
    SET_ARTICLE: '_primary_course_set_article',
    SAVE_EDITOR_CODE: '_primary_course_save_editor_code',
    SET_CHOOSE_EXERCISE_ANSWER: '_primary_course_set_choose_exercise_answer',
    LOADING: '_primary_course_loading'
  },
  courseEntry: {
    SET_CATALOGS: '_course_entry_set_catalogs',
    EXPAND_CATALOG: '_course_entry_collapse_catalog',
    SET_PROGRESS: '_course_entry_set_progress',
    SET_BASE_INFO: '_course_entry_set_base_info',
    SET_LEARN_INFO: '_course_entry_set_learn_info',
    SET_COURSE_INFOS: '_course_entry_set_course_infos',
    SET_ACTIVE_COURSE_INDEX: '_course_entry_set_active_course_index'
  },
  userInfo: {
    SET_USER_INFO: '_user_info_set_user_info',
    SET_WX_BOUND: '_user_info_set_wx_bound',
  },
  playground: {
    TOGGLE_FILES: '_playground_toggle_files',
    UPDATE_FILES: '_playground_update_files'
  }
}
